<script>
    export let value;
    export let min;
    export let max;
    export let step;
</script>

<span class="slider">
    <slot {value}></slot>
    <input on:change type="range" {min} {max} {step} bind:value={value} />
</span>

<style>
    .slider {
        vertical-align: middle;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
    }
</style>